import React, { Component } from 'react';
import DataTable from 'react-data-table-component';
import $ from "jquery";
import { ToastContainer, toast } from "react-toastify";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { tokenVerification } from './Utils';

class Billing extends Component {
    constructor() {
        super();
        this.state = {
            dataStartedProcessing: false,
            showLoader: false,
            dummyData: [{
                id: '',
                cptCode: "",
                duration: "",
                pricing: "",
            }],
            editedCptCode: "",
            editedDuration: "",
            editedPricing: "",
            disabled: false,
            editedId: "-1",
            pageNum: null,
            paginationValue: 10,
            hidden: false,
            hideDeletePopup: false,
            hideDeleteSuccessPopup: false,
            searchTerm: "",
            noMatchingData: false,
            isLoading: true,
        }
        this.saveImageSrc = "./assets/images/baseline_save_white_24dp.png";
        this.editImageSrc = "./assets/images/edit2.png";
    }
    componentDidMount() {
        var thisController = this;

        this.fetchBillingDetails();

        if (this.props.location.state != undefined) {
            this.setState({ pageNum: this.props.location.state.pageNum });
        }

    }
    addNewBillingRow = () => {
        var thisController = this;
        thisController.state.paginationValue = thisController.state.paginationValue + 5;
        if (thisController.state.pageNum != 0) {
            thisController.setState({ pageNum: 0 })
        }
        this.state.data.unshift({
            id: '',
            cptCode: "",
            duration: "",
            pricing: "",
        });
        this.setState({
            noMatchingData: false,
            data: this.state.data,
            disabled: true,
        })
    }

    makeCelledit(row, e) {
        this.markAsBeingEdited(row.id);
        this.state.editedCptCode = row.cptCode;
        this.state.editedDuration = row.duration;
        this.state.editedPricing = row.pricing;
        this.setState(this.state);
    }

    markAsBeingEdited(id) {
        this.state.editedId = id;
        var stateObj = this.state;
        this.setState(stateObj);
    }

    CustomNoDataComponent = () => (
        <div style={{ padding: '20px', textAlign: 'center' }}>
            <p>There are no billing data present. </p>
        </div>
    );

    fetchBillingDetails = () => {
        var thisController = this;
        $.ajax({
            url: "/my-jeeva-api/load-billing",
            method: 'GET',
            headers: {
                'Authorization': "Bearer " + localStorage.getItem("access_token"),
            },
            success: function (res) {
                if (res.success === true) {
                    var messages = res.result;
                    thisController.state.disabled = false;
                    thisController.state.showLoader = true;
                    thisController.state.data = messages;
                    thisController.state.noMatchingData = false;
                    thisController.state.isLoading = false;
                    thisController.data = messages;
                    thisController.setState(thisController.state);
                } else {
                    thisController.state.isLoading = false;
                    thisController.state.noMatchingData = false;
                    thisController.setState(thisController.state);
                    // thisController.notifyError(res.result);
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    tokenVerification();
                }
            }
        });
    }

    saveBillingDetails(row, e) {
        var thisController = this;
        // var namePattern = new RegExp(/^([a-zA-Z\s-])*$/);

        row.cptCode = document.getElementById("cptCode" + row.id).innerText.trim();
        row.duration = document.getElementById("duration" + row.id).innerText.trim();
        row.pricing = document.getElementById("pricing" + row.id).innerText.trim();


        var cptCode = row.cptCode;
        var duration = row.duration;
        var pricing = row.pricing;
        if (cptCode == "" || duration == "" || pricing == "") {
            thisController.notifyMsgFieldEmpty();
        } else {
            thisController.state.editedId = "-1";
            thisController.state.dataStartedProcessing = true;
            thisController.setState(thisController.state);
            var saveData = {
                cptCode: row.cptCode,
                duration: row.duration,
                pricing: row.pricing,
            }

            var timer = setInterval(function () {
                clearTimeout(timer);

                $.ajax({
                    url: "/my-jeeva-api/add-billing",
                    method: 'POST',
                    headers: {
                        'Authorization': "Bearer " + localStorage.getItem("access_token"),
                        'Content-Type': "application/json",

                    },
                    data: JSON.stringify(saveData),
                    success: function (res) {
                        if (res.success === true) {
                            thisController.state.dataStartedProcessing = false;
                            thisController.notifyBillingAdded();
                            thisController.fetchBillingDetails();
                            thisController.setState({ disabled: false, dataStartedProcessing: false });
                        } else {
                            thisController.notifyFailedResponse(res.result);
                        }
                    },
                    error: function (xhr) {
                        if (xhr.status == 401) {
                            tokenVerification();
                        }
                    }
                })

            }, 2000);
        }
    }

    updateBillingDetails(row, e) {
        row.cptCode = document.getElementById("cptCode" + row.id).innerText.trim();
        row.duration = document.getElementById("duration" + row.id).innerText.trim();
        row.pricing = document.getElementById("pricing" + row.id).innerText.trim();
        var thisController = this;



        var cptCode = thisController.state.editedCptCode;
        var duration = thisController.state.editedDuration;
        var pricing = thisController.state.editedPricing;

        if (cptCode == "" || duration == "" || pricing == "") {
            thisController.notifyMsgFieldEmpty();
        } else {
            var updatedData = {
                id: row.id,
                cptCode: cptCode,
                duration: duration,
                pricing: pricing,
            };
            $.ajax({
                url: "/my-jeeva-api/update-billing",
                method: 'PATCH',
                headers: {
                    'Authorization': "Bearer " + localStorage.getItem("access_token"),
                    'Content-Type': 'application/json',
                },
                data: JSON.stringify(updatedData),
                contentType: "application/json; charset=UTF-8",
                success: function (res) {
                    if (res.success === true) {
                        thisController.state.editedId = "-1";
                        thisController.notifyBillingUpdate();
                        thisController.fetchBillingDetails();
                    } else {
                        thisController.notifyFailedResponse(res.result);
                    }
                },
                error: function (xhr) {
                    if (xhr.status == 401) {
                        window.location.href = "";
                    }
                }


            })
        }

    }
    openDeletePopUp = (row) => {

        confirmAlert({
            title: 'Confirm to Delete',
            message: `Are you sure you want to delete  ${row.cptCode} ?`,
            buttons: [
                {
                    label: 'Yes',
                    onClick: () => this.deleteBillingDetail(row.id)
                },
                {
                    label: 'No',
                }
            ]
        });
    }

    deleteBillingDetail = (id) => {
        let billingData = this.state.data;
        let deleteApiViewController = this;
        var deleteConstructorVariables = this;

        if (id == "") {
            deleteApiViewController.setState({ deleteRow: true });
            deleteConstructorVariables.setState({ hideDeletePopup: false });
            deleteConstructorVariables.setState({ hideDeleteSuccessPopup: true });
            billingData.splice(id, 1);
        } else {
            $.ajax({
                url: "/my-jeeva-api/delete-billing/" + id,

                method: 'DELETE',
                headers: { "Authorization": "Bearer " + localStorage.getItem("access_token") },
                success: function (res) {

                    if (res.success === true) {

                        deleteApiViewController.setState({ deleteRow: true });
                        deleteConstructorVariables.setState({ hideDeletePopup: false });
                        deleteConstructorVariables.notifyDelete();
                        billingData.splice(id, 1);
                        deleteApiViewController.refreshData();
                    } else {
                        // deleteConstructorVariables.notifyError();
                    }
                },
                error: function (xhr) {
                    if (xhr.status == 401) {
                        tokenVerification();
                    }
                }
            });
        }

        if (this.state.deleteRow) {
            this.state.data.splice(id, 1);
        }
        deleteConstructorVariables.fetchBillingDetails();


    }
    notifyError() {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }}
            content="" />&nbsp;&nbsp;Oops! Error occurred.Please try again</b>, {
            position: "top-center"
        });
    }

    notifyFailedResponse(response) {
        toast.dismiss();
        toast(<b style={{ color: "red" }}>{response}</b>, {
            position: "top-center",
            color: "red"

        });
    }

    notifyDataProcessing() {
        toast.dismiss();
        toast(
            <b>
                <img
                    src="assets/images/warn.svg"
                    style={{ paddingRight: "0px", height: "20px", width: "20px" }}
                    content=""
                />
                &nbsp;&nbsp;Hold on.Your data is saving...
            </b>,
            {
                position: "top-center",
            }
        );
    }
    notifyBillingAdded() {
        toast.dismiss();
        toast(
            <b>
                <img
                    src="assets/images/done.svg"
                    style={{ paddingRight: "0px" }}
                    content=""
                />
                &nbsp;&nbsp;Billing Details added successfully
            </b>,
            {
                position: "top-center",
            }
        );
    }
    notifyBillingUpdate() {
        toast.dismiss();
        toast(
            <b>
                <img
                    src="assets/images/done.svg"
                    style={{ paddingRight: "0px" }}
                    content=""
                />
                &nbsp;&nbsp;Billing Details updated successfully
            </b>,
            {
                position: "top-center",
            }
        );
    }

    notifyImproperName() {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg"
            style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />
            &nbsp;&nbsp;Please provide a valid name</b>, {
            position: "top-center"
        });
    }

    notifyDelete() {
        toast.dismiss();
        toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />&nbsp;&nbsp;Billing Detail deleted successfully</b>, {
            position: "top-center",
        });
    }

    notifyMsgFieldEmpty() {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg"
            style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />
            &nbsp;&nbsp;Please fill all the fields</b>, {
            position: "top-center"
        });

    }
    refreshData = (id) => {
        console.log("Resetting the data");
        this.state.isLoading = true;
        this.state.noMatchingData = false;
        this.state.data = [];
        this.state.editedId = "-1";
        this.state.disabled = false;
        this.state.searchTerm = "";
        this.setState(this.state);
        this.fetchBillingDetails();
    }

    handleCPTCodeChange = (e) => {
        this.state.editedCptCode = e.currentTarget.textContent.trim();
        this.setState(this.state);
    }

    handleDurationChange = (e) => {
        this.state.editedDuration = e.currentTarget.textContent.trim();
        this.setState(this.state);
    }

    handlePricingChange = (e) => {
        this.state.editedPricing = e.currentTarget.textContent.trim();
        this.setState(this.state);
    }



    onPageChange = (e) => {
        this.setState({ pageNum: e })
    }

    randomNumber(min, max) {
        return Math.floor(Math.random() * (max - min) + min);
    }

    caseInsensitiveSort = (field) => (rowA, rowB) => {
        const a = rowA[field] ? rowA[field] : "";
        const b = rowB[field] ? rowB[field] : "";

        if (a > b) {
            return 1;
        }

        if (b > a) {
            return -1;
        }

        return 0;
    };

    handleSearch = (event) => {
        var thisController = this;
        thisController.state.searchTerm = event.target.value;
        thisController.state.isLoading = true;
        thisController.state.data = [];
        thisController.setState(thisController.state);

        $.ajax({
            url: "/my-jeeva-api/search-billing-data",
            method: "GET",
            data: {
                searchTerm: thisController.state.searchTerm
            },
            headers: {
                Authorization: "Bearer " + localStorage.getItem("access_token"),
            },

            success: function (res) {
                if (res.success === true) {
                    if (res.result.length > 0) {
                        thisController.state.noMatchingData = false;
                        thisController.state.data = [];
                        thisController.setState(thisController.state);
                        thisController.state.isLoading = false;
                        thisController.state.data = res.result;
                        thisController.setState(thisController.state);
                    } else {
                        thisController.state.noMatchingData = true;
                        thisController.setState(thisController.state);
                    }
                }
            },
            error: function (xhr) {

            },
        });

    };

    render() {


        const columns = [
            {
                name: <b style={{ fontSize: "16px" }}> CPT Code</b>,
                sortable: true,
                sortFunction: this.caseInsensitiveSort('cptCode'),
                // width: "19vw",
                selector: (row) => (
                    <div name="cptCode">
                        <div
                            className="textarea"
                            style={{
                                background: "white",
                                height: "2.7em",
                                resize: "none",
                                paddingLeft: "2px",
                                paddingTop: "6px",
                                width: "100%",
                                fontSize: "15px",
                                border:
                                    row.id == "" || row.id == this.state.editedId
                                        ? "1px solid #D2D4DC"
                                        : "none",
                                borderRadius: row.id == "" ? "2px" : "none",
                            }}
                            onInput={(e) => {
                                this.handleCPTCodeChange(e, row);
                            }}
                            id={"cptCode" + row.id}
                            contentEditable={
                                !(row.id == "" ? false : row.id != this.state.editedId)
                                    ? "plaintext-only"
                                    : false
                            }
                        >
                            {row.cptCode}
                        </div>
                    </div>
                ),
            },
            {
                name: <b style={{ fontSize: "16px" }}>Duration</b>,
                sortable: true,
                sortFunction: this.caseInsensitiveSort('duration'),
                // width: "45vw",
                selector: (row) => (
                    <div>
                        <div
                            className="textarea"
                            style={{
                                background: "white",
                                height: "2.7em",
                                resize: "none",
                                paddingLeft: "2px",
                                paddingTop: "6px",
                                width: "100%",
                                border:
                                    row.id == "" || row.id == this.state.editedId
                                        ? "1px solid #D2D4DC"
                                        : "none",
                                borderRadius: row.id == "" ? "2px" : "none",
                            }}
                            onInput={(e) => {
                                this.handleDurationChange(e, row);
                            }}
                            id={"duration" + row.id}
                            name={"duration" + row.id}
                            contentEditable={
                                !(row.id == "" ? false : row.id != this.state.editedId)
                                    ? "plaintext-only"
                                    : false
                            }
                        >
                            {row.duration}
                        </div>
                    </div>
                ),
            },
            {
                name: <b style={{ fontSize: "16px" }}>Pricing</b>,
                sortable: true,
                sortFunction: this.caseInsensitiveSort('pricing'),
                // width: "45vw",
                selector: (row) => (
                    <div>
                        <div
                            className="textarea"
                            style={{
                                background: "white",
                                height: "2.7em",
                                resize: "none",
                                paddingLeft: "2px",
                                paddingTop: "6px",
                                width: "100%",
                                border:
                                    row.id == "" || row.id == this.state.editedId
                                        ? "1px solid #D2D4DC"
                                        : "none",
                                borderRadius: row.id == "" ? "2px" : "none",
                            }}
                            onInput={(e) => {
                                this.handlePricingChange(e, row);
                            }}
                            id={"pricing" + row.id}
                            name={"pricing" + row.id}
                            contentEditable={
                                !(row.id == "" ? false : row.id != this.state.editedId)
                                    ? "plaintext-only"
                                    : false
                            }
                        >
                            {row.pricing}
                        </div>
                    </div>
                ),
            },
            {
                name: <b style={{ fontSize: "16px" }}>Actions</b>,
                width: 100,
                selector: (row) => (
                    <div id="action">
                        <button
                            style={{
                                backgroundColor: "#ffffff",
                                border: "none",
                                marginLeft: '-6px'
                            }} >
                            <img className="img-responsive"
                                title={row.id == "" || (row.id == this.state.editedId) ? 'Save' : 'Edit'}
                                style={{
                                    marginTop: '6px',
                                    backgroundColor: '#282a65',
                                    borderRadius: '5px',
                                    padding: '1px',
                                    width: '100%',
                                    fontSize: '15px'
                                }}
                                src={row.id == "" ? this.saveImageSrc : ((row.id != this.state.editedId) ? this.editImageSrc : this.saveImageSrc)}
                                onClick={(e) => {
                                    this.state.dataStartedProcessing
                                        ? this.notifyDataProcessing() :
                                        row.id == "" ? this.saveBillingDetails(row, e) : (row.id == this.state.editedId) ?
                                            this.updateBillingDetails(row, e) : this.makeCelledit(row, e);
                                }}
                            />
                        </button>
                        <button
                            style={{
                                backgroundColor: "#ffffff",
                                border: "none",
                                marginTop: '-9px',
                                marginLeft: '-6px'
                            }}
                            title="Delete">
                            <img className="img-responsive"
                                src={"./assets/images/baseline_delete_white_24dp.png"}
                                title="Delete"
                                style={{
                                    marginTop: '6px',
                                    backgroundColor: '#282a65',
                                    borderRadius: '5px',
                                    padding: '1px'
                                }}
                                onClick={() => (row.id) === '' ?
                                    this.fetchBillingDetails() :
                                    this.openDeletePopUp(row)}
                            />
                        </button >
                    </div>
                ),
            },
        ];
        return (
            <div style={{ background: "#F9F9FB", marginRight: "1%" }}>
                {/* for toaster */}
                <link rel="stylesheet" href="assets/css/ReactToastify.css" />
                {/* for reactTable */}
                <link rel="stylesheet" href="assets/css/React_Table_CSS/react-table.css" />


                {/*for dialog component */}
                <link href="assets/css/ej2-base.css" rel="stylesheet" />
                <link href="assets/css/ej2-react-buttons.css" rel="stylesheet" />
                <link href="assets/css/ej2-react-popups.css" rel="stylesheet" />
                <link href="assets/css/ej2-inputs.css" rel="stylesheet" />
                <link href="assets/css/screenResolution.css" rel="stylesheet" />
                {/* Font Awesome Icons */}
                <link rel="stylesheet" href="plugins/font-awesome/css/font-awesome.min.css" />
                {/* IonIcons */}
                <link rel="stylesheet" href="assets/fonts/flat-icon/flaticon.css" />
                {/* Select2 */}
                <link rel="stylesheet" href="plugins/select2/select2.min.css" />
                <link rel="stylesheet" href="assets/css/toggleButton.css" />
                <link rel="stylesheet" href="./assets/css/styles.css" />
                <div className="row" style={{ marginLeft: "15px" }}>
                    <div className="col-sm-4" style={{ marginTop: '2px' }} >

                    </div>
                </div>

                <div className="row" style={{ marginLeft: '14px' }}>
                    <div className="col-sm-5">
                        <h6 className="nav-item" style={{ color: '#282a65', marginTop: '15px' }}>
                            Billing</h6>
                    </div>
                    <div className="col-sm-5" Align="right">
                        <input
                            type="text"
                            style={{
                                width: "12vw",
                                border: "2px solid #777676",
                                borderRadius: "10px",
                                padding: "10px",
                                height: "0.7vw"
                            }}
                            value={this.state.searchTerm}
                            onChange={this.handleSearch}
                            placeholder="Search ..."
                        />
                    </div>
                    <div className="col-sm-2 " id='addrefresh-btn' style={{ marginTop: '-18px' }}>
                        <div className="d-flex flex-row-reverse pt-2">

                            <div className="p-2" style={{ marginBottom: '10px' }}>

                                <button className="btn action-button"
                                    id="addMsg" title=" Add "
                                    onClick={this.state.disabled ? this.notifyMsgFieldEmpty : this.addNewBillingRow}
                                >
                                    <img src="assets/images/add_white_24dp.png" />
                                </button>
                                <button title="Refresh"
                                    onClick={this.refreshData}
                                    type="button" className="btn action-button">
                                    <img src="./assets/images/refresh_white_24dp.png"></img>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row" style={{ marginLeft: '15px', marginTop: '-15px' }}>
                    <div className="col-lg-12 ">
                        {!this.state.noMatchingData &&
                            <div className="card">
                                {this.state.isLoading && (
                                    <div style={{ padding: '20px', textAlign: 'center' }}>
                                        <p>Loading ...</p>
                                    </div>
                                )}
                                {!this.state.isLoading && this.state.data.length === 0 && (
                                    <div style={{ padding: '20px', textAlign: 'center' }}>
                                        <p>There are no billing data present.</p>
                                    </div>
                                )}
                                {(!this.state.isLoading && this.state.data.length > 0) && (
                                    <DataTable
                                        data={this.state.data}
                                        columns={columns}
                                        defaultPageSize={10}
                                        pageSizeOptions={[5, 10, 15]}
                                        pagination={this.state.paginationValue}
                                        onPageChange={this.onPageChange}
                                        page={this.state.pageNum}
                                        noDataComponent={<this.CustomNoDataComponent />}

                                    />
                                )}
                            </div>
                        }
                        <ToastContainer className="Toast-at-center" />
                    </div>
                </div>
                <div className='card'>
                    {this.state.noMatchingData &&
                        <div style={{ padding: '20px', textAlign: 'center', boxShadow: "0 0 10px rgba(0, 0, 0, 0.2)" }}>
                            <p>No matching options found ...</p>
                        </div>
                    }
                </div>
            </div>
        )
    }
}


export default Billing;


// WEBPACK FOOTER //
// src/my-jeeva/projectmgmt/Billing.js